export function LogOut3Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.464 15.9L22 12.364a1 1 0 000-1.414l-3.536-3.536a1 1 0 10-1.414 1.414l1.879 1.88H6.707a1 1 0 100 2h12.121l-1.778 1.777a1 1 0 101.414 1.415z"
      ></path>
      <path
        fill="currentColor"
        d="M10.707 6.707a1 1 0 00-1-1h-5a1 1 0 00-1 1v10a1 1 0 001 1h5a1 1 0 001-1v-.5a1 1 0 112 0v.5a3 3 0 01-3 3h-5a3 3 0 01-3-3v-10a3 3 0 013-3h5a3 3 0 013 3v.5a1 1 0 11-2 0v-.5z"
      ></path>
    </svg>
  );
}
